package com.kinoshazam.screens.decide

import androidx.compose.foundation.Canvas
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.GridItemSpan
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.lazy.grid.items
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Scaffold
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.platform.LocalClipboardManager
import androidx.compose.ui.text.AnnotatedString
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import com.kinoshazam.screens.details.medium.DialogContent
import com.kinoshazam.taste.TasteCatalogItem
import com.kinoshazam.taste.TasteCompany
import com.kinoshazam.taste.TasteDuration
import com.kinoshazam.taste.TasteMood
import com.kinoshazam.taste.TasteReasonKeys
import com.kinoshazam.taste.TasteTags
import com.kinoshazam.taste.TasteVoteKind
import com.kinoshazam.taste.isLocked
import com.kinoshazam.uiKit.button.ButtonContentState
import com.kinoshazam.uiKit.button.UiKitButton
import com.kinoshazam.uiKit.button.UiKitButtonState
import com.kinoshazam.uiKit.components.image.ImageUiKitState
import com.kinoshazam.uiKit.components.image.UiKitImage
import com.kinoshazam.uiKit.components.textField.TextFieldState
import com.kinoshazam.uiKit.components.textField.compact.CompactTextField
import com.kinoshazam.uiKit.components.textLabel.TextLabel
import com.kinoshazam.uiKit.components.textLabel.TextLabelState
import com.kinoshazam.uiKit.theme.BoldLarge
import com.kinoshazam.uiKit.theme.BoldMedium
import com.kinoshazam.uiKit.theme.Medium
import com.kinoshazam.uiKit.theme.MediumSmall
import com.kinoshazam.uiKit.theme.UiKitTheme
import androidx.compose.ui.text.style.TextAlign
import com.kinoshazam.view.ErrorView
import com.kinoshazam.view.OnBackPressed
import kinoshazam.resources.generated.resources.Res
import kinoshazam.resources.generated.resources.decide_already_watched
import kinoshazam.resources.generated.resources.decide_another
import kinoshazam.resources.generated.resources.decide_company_family
import kinoshazam.resources.generated.resources.decide_company_hall
import kinoshazam.resources.generated.resources.decide_company_solo
import kinoshazam.resources.generated.resources.decide_company_title
import kinoshazam.resources.generated.resources.decide_constraints_title
import kinoshazam.resources.generated.resources.decide_preferences_title
import kinoshazam.resources.generated.resources.decide_with_subtitles
import kinoshazam.resources.generated.resources.decide_duration_long
import kinoshazam.resources.generated.resources.decide_duration_short
import kinoshazam.resources.generated.resources.decide_duration_standard
import kinoshazam.resources.generated.resources.decide_duration_title
import kinoshazam.resources.generated.resources.decide_edit_seeds
import kinoshazam.resources.generated.resources.decide_exit_body
import kinoshazam.resources.generated.resources.decide_exit_leave
import kinoshazam.resources.generated.resources.decide_exit_stay
import kinoshazam.resources.generated.resources.decide_exit_title
import kinoshazam.resources.generated.resources.decide_exclude_watched
import kinoshazam.resources.generated.resources.decide_high_rating
import kinoshazam.resources.generated.resources.decide_join_cta
import kinoshazam.resources.generated.resources.decide_join_error
import kinoshazam.resources.generated.resources.decide_join_hint
import kinoshazam.resources.generated.resources.decide_join_missing_body
import kinoshazam.resources.generated.resources.decide_join_missing_code
import kinoshazam.resources.generated.resources.decide_join_missing_title
import kinoshazam.resources.generated.resources.decide_join_placeholder
import kinoshazam.resources.generated.resources.decide_join_start_own
import kinoshazam.resources.generated.resources.decide_join_title
import kinoshazam.resources.generated.resources.decide_mood_funny
import kinoshazam.resources.generated.resources.decide_mood_light
import kinoshazam.resources.generated.resources.decide_mood_surprise
import kinoshazam.resources.generated.resources.decide_mood_tense
import kinoshazam.resources.generated.resources.decide_mood_title
import kinoshazam.resources.generated.resources.decide_next
import kinoshazam.resources.generated.resources.decide_not_for_me
import kinoshazam.resources.generated.resources.decide_party_copied
import kinoshazam.resources.generated.resources.decide_party_copy
import kinoshazam.resources.generated.resources.decide_party_code_hint
import kinoshazam.resources.generated.resources.decide_party_host
import kinoshazam.resources.generated.resources.decide_party_limit
import kinoshazam.resources.generated.resources.decide_party_limit_n
import kinoshazam.resources.generated.resources.decide_party_limit_none
import kinoshazam.resources.generated.resources.decide_party_pick_now
import kinoshazam.resources.generated.resources.decide_party_ready
import kinoshazam.resources.generated.resources.decide_party_slots
import kinoshazam.resources.generated.resources.decide_party_slots_open
import kinoshazam.resources.generated.resources.decide_party_title
import kinoshazam.resources.generated.resources.decide_party_wait_host
import kinoshazam.resources.generated.resources.decide_party_waiting
import kinoshazam.resources.generated.resources.decide_party_you
import kinoshazam.resources.generated.resources.decide_party_votes
import kinoshazam.resources.generated.resources.decide_party_lock
import kinoshazam.resources.generated.resources.decide_party_locked
import kinoshazam.resources.generated.resources.decide_pick_empty
import kinoshazam.resources.generated.resources.decide_reason_family
import kinoshazam.resources.generated.resources.decide_reason_from_taste
import kinoshazam.resources.generated.resources.decide_reason_high_rating
import kinoshazam.resources.generated.resources.decide_reason_mood
import kinoshazam.resources.generated.resources.decide_reason_popular
import kinoshazam.resources.generated.resources.decide_reason_similar
import kinoshazam.resources.generated.resources.decide_reason_surprise
import kinoshazam.resources.generated.resources.decide_reason_time
import kinoshazam.resources.generated.resources.decide_reason_together
import kinoshazam.resources.generated.resources.decide_seeds_count
import kinoshazam.resources.generated.resources.decide_seeds_hint
import kinoshazam.resources.generated.resources.decide_seeds_more
import kinoshazam.resources.generated.resources.decide_seeds_title
import kinoshazam.resources.generated.resources.decide_tag_animation
import kinoshazam.resources.generated.resources.decide_tag_horror
import kinoshazam.resources.generated.resources.decide_tag_romance
import kinoshazam.resources.generated.resources.decide_tag_slow
import kinoshazam.resources.generated.resources.decide_tag_violence
import kinoshazam.resources.generated.resources.decide_title
import kinoshazam.resources.generated.resources.decide_vote_pass
import kinoshazam.resources.generated.resources.decide_vote_seen
import kinoshazam.resources.generated.resources.decide_vote_skip
import kinoshazam.resources.generated.resources.decide_vote_watch
import kinoshazam.resources.generated.resources.decide_watch
import kinoshazam.resources.generated.resources.decide_watch_in
import kinoshazam.resources.generated.resources.close
import kinoshazam.resources.generated.resources.error
import kinoshazam.resources.generated.resources.left
import kinoshazam.resources.generated.resources.movie
import kinoshazam.resources.generated.resources.repeat
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel
import presentation.screens.decide.DecideMVIAction
import presentation.screens.decide.DecideState
import presentation.screens.decide.DecideStep
import presentation.screens.decide.DecideViewModel
import utils.FormFactor

@Composable
fun DecideContentHost(
    formFactor: FormFactor = FormFactor.Compact,
) {
    val viewModel = koinViewModel<DecideViewModel>()
    val state by viewModel.state.collectAsStateWithLifecycle()
    val onAction = viewModel::onAction

    OnBackPressed {
        if (state.askExitConfirm) {
            onAction(DecideMVIAction.DismissExit)
        } else {
            onAction(DecideMVIAction.Back)
        }
    }

    Box(modifier = Modifier.fillMaxSize()) {
        when (formFactor) {
            FormFactor.Expanded, FormFactor.ExtraLarge -> {
                DialogContent(onClose = { onAction(DecideMVIAction.RequestExit) }) {
                    DecideContent(
                        state = state,
                        onAction = onAction,
                        asDialog = true,
                    )
                }
            }
            else -> DecideContent(
                state = state,
                onAction = onAction,
                asDialog = false,
            )
        }
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun DecideContent(
    state: DecideState,
    onAction: (DecideMVIAction) -> Unit,
    asDialog: Boolean,
) {
    val pickHero = state.step == DecideStep.PICK && !state.isLoading && state.pick != null
    Box(modifier = Modifier.fillMaxSize()) {
        if (pickHero) {
            PickHeroBackground(imageUrl = state.pick?.imageUrl)
        }
        Scaffold(
            containerColor = if (pickHero) Color.Transparent else UiKitTheme.colors.color_3,
        topBar = {
            TopAppBar(
                title = {
                    TextLabel(
                        state = TextLabelState(
                            text = stringResource(Res.string.decide_title),
                            color = UiKitTheme.colors.color_2,
                            textStyle = BoldLarge,
                        )
                    )
                },
                navigationIcon = {
                    Image(
                        painter = painterResource(Res.drawable.left),
                        colorFilter = ColorFilter.tint(UiKitTheme.colors.color_2),
                        contentDescription = null,
                        modifier = Modifier
                            .padding(start = 12.dp)
                            .size(24.dp)
                            .clickable { onAction(DecideMVIAction.Back) },
                    )
                },
                actions = {
                    if (!asDialog) {
                        Image(
                            painter = painterResource(Res.drawable.close),
                            colorFilter = ColorFilter.tint(UiKitTheme.colors.color_2),
                            contentDescription = null,
                            modifier = Modifier
                                .padding(end = 12.dp)
                                .size(24.dp)
                                .clickable { onAction(DecideMVIAction.RequestExit) },
                        )
                    }
                },
                colors = TopAppBarDefaults.topAppBarColors(
                    containerColor = if (pickHero) Color.Transparent else UiKitTheme.colors.color_3,
                    scrolledContainerColor = if (pickHero) Color.Transparent else UiKitTheme.colors.color_3,
                ),
                windowInsets = if (asDialog) WindowInsets(0) else TopAppBarDefaults.windowInsets,
            )
        },
        bottomBar = {
            val showBar = !state.isLoading && !state.isSaving &&
                !state.isError &&
                !state.hallNotFound &&
                state.step != DecideStep.PICK &&
                (state.step != DecideStep.LOBBY || state.party?.canPick == true)
            if (showBar) {
                DecideBottomBar(state = state, onAction = onAction)
            }
        }
    ) { padding ->
        DecideStepBody(
            padding = padding,
            state = state,
            onAction = onAction,
            asDialog = asDialog,
        )
    }
        if (state.askExitConfirm) {
            ExitConfirmOverlay(onAction = onAction)
        }
    }
}

@Composable
private fun DecideBottomBar(
    state: DecideState,
    onAction: (DecideMVIAction) -> Unit,
) {
    val canNext = when (state.step) {
        DecideStep.DURATION -> state.duration != null
        DecideStep.COMPANY -> state.company != null
        DecideStep.MOOD -> state.mood != null
        DecideStep.CONSTRAINTS -> true
        DecideStep.SEEDS -> state.canContinueSeeds
        DecideStep.LOBBY -> state.party?.canPick == true
        DecideStep.PICK -> false
    }
    val nextTitle = if (state.step == DecideStep.LOBBY) {
        stringResource(Res.string.decide_party_pick_now)
    } else {
        stringResource(Res.string.decide_next)
    }
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .background(UiKitTheme.colors.color_3)
            .navigationBarsPadding()
            .padding(16.dp)
    ) {
        UiKitButton(
            state = UiKitButtonState(
                title = nextTitle,
                titleColor = UiKitTheme.colors.color_7,
                backgroundColor = UiKitTheme.colors.color_1,
                contentState = when {
                    state.isSaving -> ButtonContentState.LOADING
                    canNext -> ButtonContentState.ENABLED
                    else -> ButtonContentState.DISABLED
                },
            ),
            onClick = if (canNext && !state.isSaving) {
                { onAction(DecideMVIAction.Next) }
            } else {
                null
            },
            modifier = Modifier.fillMaxWidth(),
        )
    }
}

@Composable
private fun DecideStepBody(
    padding: PaddingValues,
    state: DecideState,
    onAction: (DecideMVIAction) -> Unit,
    asDialog: Boolean,
) {
    if (state.isLoading && state.step != DecideStep.PICK) {
        Box(
            modifier = Modifier.fillMaxSize().padding(padding),
            contentAlignment = Alignment.Center,
        ) {
            CircularProgressIndicator(color = UiKitTheme.colors.color_1, strokeWidth = 2.dp)
        }
        return
    }

    if (state.hallNotFound) {
        JoinMissingBlock(
            padding = padding,
            state = state,
            onAction = onAction,
            asDialog = asDialog,
        )
        return
    }

    if (state.isError) {
        ErrorView(
            textError = stringResource(Res.string.error),
            textAction = stringResource(Res.string.repeat),
            onAction = { onAction(DecideMVIAction.Reload) },
            modifier = Modifier.padding(padding),
        )
        return
    }

    if (state.step == DecideStep.SEEDS) {
        Column(modifier = Modifier.padding(padding).fillMaxSize()) {
            TextLabel(
                state = TextLabelState(
                    text = stringResource(Res.string.decide_seeds_title),
                    color = UiKitTheme.colors.color_2,
                    textStyle = BoldMedium,
                ),
                modifier = Modifier.padding(horizontal = 16.dp, vertical = 8.dp),
            )
            TextLabel(
                state = TextLabelState(
                    text = stringResource(Res.string.decide_seeds_hint),
                    color = UiKitTheme.colors.color_2,
                    textStyle = Medium,
                ),
                modifier = Modifier.padding(horizontal = 16.dp),
            )
            TextLabel(
                state = TextLabelState(
                    text = stringResource(Res.string.decide_seeds_count, state.selectedSeeds.size),
                    color = UiKitTheme.colors.color_1,
                    textStyle = Medium,
                ),
                modifier = Modifier.padding(16.dp),
            )
            LazyVerticalGrid(
                columns = GridCells.Adaptive(minSize = 120.dp),
                contentPadding = PaddingValues(horizontal = 12.dp, vertical = 8.dp),
                horizontalArrangement = Arrangement.spacedBy(8.dp),
                verticalArrangement = Arrangement.spacedBy(8.dp),
                modifier = Modifier.weight(1f),
            ) {
                items(state.candidates, key = { it.videoId }) { item ->
                    SeedCard(item = item, selected = state.selectedSeeds.any { it.videoId == item.videoId }, onAction = onAction)
                }
                if (state.isLoadingSeeds && state.candidates.isEmpty()) {
                    item(span = { GridItemSpan(maxLineSpan) }) {
                        Box(
                            modifier = Modifier.fillMaxWidth().padding(24.dp),
                            contentAlignment = Alignment.Center,
                        ) {
                            CircularProgressIndicator(
                                color = UiKitTheme.colors.color_1,
                                strokeWidth = 2.dp,
                                modifier = Modifier.size(24.dp),
                            )
                        }
                    }
                }
                if ((state.candidates.isNotEmpty() || !state.isLoadingSeeds) &&
                    (!state.seedsExhausted || state.isLoadingSeeds)
                ) {
                    item(span = { GridItemSpan(maxLineSpan) }) {
                        UiKitButton(
                            state = UiKitButtonState(
                                title = stringResource(Res.string.decide_seeds_more),
                                titleColor = UiKitTheme.colors.color_2,
                                backgroundColor = UiKitTheme.colors.color_4,
                                contentState = if (state.isLoadingSeeds && state.candidates.isNotEmpty()) {
                                    ButtonContentState.LOADING
                                } else {
                                    ButtonContentState.ENABLED
                                },
                            ),
                            onClick = if (!state.isLoadingSeeds) {
                                { onAction(DecideMVIAction.LoadMoreSeeds) }
                            } else {
                                null
                            },
                            modifier = Modifier.fillMaxWidth().padding(vertical = 8.dp),
                        )
                    }
                }
            }
        }
        return
    }

    if (state.step == DecideStep.LOBBY) {
        LobbyStep(
            padding = padding,
            state = state,
            onAction = onAction,
        )
        return
    }

    if (state.step == DecideStep.PICK) {
        PickStep(
            padding = padding,
            state = state,
            onAction = onAction,
        )
        return
    }

    Column(
        modifier = Modifier
            .padding(padding)
            .fillMaxSize()
            .verticalScroll(rememberScrollState())
            .padding(horizontal = 16.dp, vertical = 8.dp)
    ) {
        when (state.step) {
            DecideStep.DURATION -> {
                if (state.party == null) {
                    JoinHallBlock(state = state, onAction = onAction)
                    Spacer(Modifier.height(24.dp))
                }
                ChoiceList(
                    title = stringResource(Res.string.decide_duration_title),
                    options = listOf(
                        TasteDuration.SHORT to stringResource(Res.string.decide_duration_short),
                        TasteDuration.STANDARD to stringResource(Res.string.decide_duration_standard),
                        TasteDuration.LONG to stringResource(Res.string.decide_duration_long),
                    ),
                    selected = state.duration,
                    onSelect = { onAction(DecideMVIAction.SelectDuration(it)) },
                )
            }
            DecideStep.COMPANY -> ChoiceList(
                title = stringResource(Res.string.decide_company_title),
                options = listOf(
                    TasteCompany.SOLO to stringResource(Res.string.decide_company_solo),
                    TasteCompany.HALL to stringResource(Res.string.decide_company_hall),
                    TasteCompany.FAMILY to stringResource(Res.string.decide_company_family),
                ),
                selected = state.company,
                onSelect = { onAction(DecideMVIAction.SelectCompany(it)) },
            )
            DecideStep.MOOD -> ChoiceList(
                title = stringResource(Res.string.decide_mood_title),
                options = listOf(
                    TasteMood.LIGHT to stringResource(Res.string.decide_mood_light),
                    TasteMood.TENSE to stringResource(Res.string.decide_mood_tense),
                    TasteMood.FUNNY to stringResource(Res.string.decide_mood_funny),
                    TasteMood.SURPRISE to stringResource(Res.string.decide_mood_surprise),
                ),
                selected = state.mood,
                onSelect = { onAction(DecideMVIAction.SelectMood(it)) },
            )
            DecideStep.CONSTRAINTS -> ConstraintsStep(state, onAction)
            DecideStep.PICK -> Unit
            DecideStep.SEEDS -> Unit
            DecideStep.LOBBY -> Unit
        }
        if (asDialog) Spacer(Modifier.height(24.dp))
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun LobbyStep(
    padding: PaddingValues,
    state: DecideState,
    onAction: (DecideMVIAction) -> Unit,
) {
    val party = state.party
    val shareUrl = partyShareUrl(party?.code.orEmpty(), party?.inviteUrl)
    val clipboard = LocalClipboardManager.current
    Column(
        modifier = Modifier
            .padding(padding)
            .fillMaxSize()
            .verticalScroll(rememberScrollState())
            .padding(horizontal = 16.dp, vertical = 8.dp),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        TextLabel(
            state = TextLabelState(
                text = stringResource(Res.string.decide_party_title),
                color = UiKitTheme.colors.color_2,
                textStyle = BoldLarge,
            ),
        )
        Spacer(Modifier.height(8.dp))
        TextLabel(
            state = TextLabelState(
                text = stringResource(Res.string.decide_party_waiting),
                color = UiKitTheme.colors.color_1,
                textStyle = Medium,
            ),
        )
        Spacer(Modifier.height(20.dp))
        TextLabel(
            state = TextLabelState(
                text = party?.code.orEmpty(),
                color = UiKitTheme.colors.color_1,
                textStyle = BoldLarge,
            ),
        )
        Spacer(Modifier.height(8.dp))
        TextLabel(
            state = TextLabelState(
                text = stringResource(Res.string.decide_party_code_hint),
                color = UiKitTheme.colors.color_1,
                textStyle = Medium,
            ),
        )
        if (shareUrl.isNotBlank()) {
            Spacer(Modifier.height(16.dp))
            InviteQrCode(
                data = shareUrl,
                modifier = Modifier.size(220.dp),
                darkColor = UiKitTheme.colors.color_3,
                lightColor = UiKitTheme.colors.color_2,
            )
            Spacer(Modifier.height(16.dp))
            TextLabel(
                state = TextLabelState(
                    text = shareUrl,
                    color = UiKitTheme.colors.color_1,
                    textStyle = MediumSmall,
                ),
            )
            Spacer(Modifier.height(12.dp))
            UiKitButton(
                state = UiKitButtonState(
                    title = stringResource(
                        if (state.linkCopied) Res.string.decide_party_copied else Res.string.decide_party_copy
                    ),
                    titleColor = UiKitTheme.colors.color_2,
                    backgroundColor = UiKitTheme.colors.color_4,
                ),
                onClick = {
                    clipboard.setText(AnnotatedString(shareUrl))
                    onAction(DecideMVIAction.CopyInviteLink)
                },
                modifier = Modifier.fillMaxWidth(),
            )
        }
        Spacer(Modifier.height(20.dp))
        val memberCount = party?.members?.size ?: 0
        val cap = party?.capacity ?: 0
        TextLabel(
            state = TextLabelState(
                text = if (cap > 0) {
                    stringResource(Res.string.decide_party_slots, memberCount, cap)
                } else {
                    stringResource(Res.string.decide_party_slots_open, memberCount)
                },
                color = UiKitTheme.colors.color_2,
                textStyle = BoldMedium,
            ),
        )
        if (party?.youAreHost == true) {
            Spacer(Modifier.height(12.dp))
            TextLabel(
                state = TextLabelState(
                    text = stringResource(Res.string.decide_party_limit),
                    color = UiKitTheme.colors.color_1,
                    textStyle = MediumSmall,
                ),
            )
            Spacer(Modifier.height(8.dp))
            FlowRow(
                horizontalArrangement = Arrangement.spacedBy(8.dp),
                verticalArrangement = Arrangement.spacedBy(8.dp),
            ) {
                listOf(0, 10, 25, 50).forEach { limit ->
                    ChoiceChip(
                        label = if (limit == 0) {
                            stringResource(Res.string.decide_party_limit_none)
                        } else {
                            stringResource(Res.string.decide_party_limit_n, limit)
                        },
                        selected = cap == limit,
                        onClick = { onAction(DecideMVIAction.SetPartyCapacity(limit)) },
                    )
                }
            }
        }
        Spacer(Modifier.height(8.dp))
        party?.members.orEmpty().forEach { member ->
            val label = buildString {
                append(
                    when {
                        member.isYou -> stringResource(Res.string.decide_party_you)
                        else -> member.displayName
                    }
                )
                if (member.isHost) {
                    append(" · ")
                    append(stringResource(Res.string.decide_party_host))
                }
                if (member.ready) {
                    append(" · ")
                    append(stringResource(Res.string.decide_party_ready))
                }
            }
            ChoiceChip(
                label = label,
                selected = member.ready,
                onClick = {},
                modifier = Modifier.fillMaxWidth().padding(bottom = 8.dp),
            )
        }
        if (party?.youAreHost != true && party?.pick == null) {
            Spacer(Modifier.height(8.dp))
            TextLabel(
                state = TextLabelState(
                    text = stringResource(Res.string.decide_party_wait_host),
                    color = UiKitTheme.colors.color_1,
                    textStyle = Medium,
                ),
            )
        }
        Spacer(Modifier.height(16.dp))
    }
}

@Composable
private fun JoinMissingBlock(
    padding: PaddingValues,
    state: DecideState,
    onAction: (DecideMVIAction) -> Unit,
    asDialog: Boolean,
) {
    val code = state.joinCodeDraft.ifBlank { state.joiningPartyCode.orEmpty() }
    Column(
        modifier = Modifier
            .padding(padding)
            .fillMaxSize()
            .verticalScroll(rememberScrollState())
            .padding(horizontal = 16.dp, vertical = 8.dp),
    ) {
        TextLabel(
            state = TextLabelState(
                text = stringResource(Res.string.decide_join_missing_title),
                color = UiKitTheme.colors.color_2,
                textStyle = BoldLarge,
            ),
        )
        Spacer(Modifier.height(8.dp))
        TextLabel(
            state = TextLabelState(
                text = stringResource(Res.string.decide_join_missing_body),
                color = UiKitTheme.colors.color_1,
                textStyle = Medium,
            ),
        )
        if (code.isNotBlank()) {
            Spacer(Modifier.height(12.dp))
            TextLabel(
                state = TextLabelState(
                    text = stringResource(Res.string.decide_join_missing_code, code),
                    color = UiKitTheme.colors.color_2,
                    textStyle = BoldMedium,
                ),
            )
        }
        Spacer(Modifier.height(24.dp))
        JoinHallBlock(state = state, onAction = onAction)
        Spacer(Modifier.height(12.dp))
        UiKitButton(
            state = UiKitButtonState(
                title = stringResource(Res.string.decide_join_start_own),
                titleColor = UiKitTheme.colors.color_2,
                backgroundColor = UiKitTheme.colors.color_4,
            ),
            onClick = { onAction(DecideMVIAction.StartOwnPick) },
            modifier = Modifier.fillMaxWidth(),
        )
        if (asDialog) Spacer(Modifier.height(24.dp))
    }
}

@Composable
private fun JoinHallBlock(
    state: DecideState,
    onAction: (DecideMVIAction) -> Unit,
) {
    val canJoin = state.joinCodeDraft.length >= 4 && !state.isSaving
    TextLabel(
        state = TextLabelState(
            text = stringResource(Res.string.decide_join_title),
            color = UiKitTheme.colors.color_2,
            textStyle = BoldMedium,
        ),
    )
    Spacer(Modifier.height(8.dp))
    TextLabel(
        state = TextLabelState(
            text = stringResource(Res.string.decide_join_hint),
            color = UiKitTheme.colors.color_1,
            textStyle = Medium,
        ),
    )
    Spacer(Modifier.height(12.dp))
    CompactTextField(
        state = TextFieldState(
            textValue = state.joinCodeDraft,
            placeholder = TextLabelState(
                text = stringResource(Res.string.decide_join_placeholder),
                color = UiKitTheme.colors.color_6,
                textStyle = Medium,
            ),
            label = if (state.joinFailed && !state.hallNotFound) {
                TextLabelState(
                    text = stringResource(Res.string.decide_join_error),
                    color = UiKitTheme.colors.error,
                    textStyle = MediumSmall,
                )
            } else {
                null
            },
            inputType = KeyboardType.Ascii,
            imeAction = ImeAction.Go,
            isSingleLine = true,
            maxLength = 12,
            showError = state.joinFailed && !state.hallNotFound,
        ),
        keyboardActions = KeyboardActions(
            onGo = { onAction(DecideMVIAction.SubmitJoinCode) },
            onDone = { onAction(DecideMVIAction.SubmitJoinCode) },
        ),
        onValueChanged = { onAction(DecideMVIAction.UpdateJoinCode(it)) },
    )
    Spacer(Modifier.height(12.dp))
    UiKitButton(
        state = UiKitButtonState(
            title = stringResource(Res.string.decide_join_cta),
            titleColor = UiKitTheme.colors.color_7,
            backgroundColor = UiKitTheme.colors.color_1,
            contentState = when {
                state.isSaving -> ButtonContentState.LOADING
                canJoin -> ButtonContentState.ENABLED
                else -> ButtonContentState.DISABLED
            },
        ),
        onClick = if (canJoin) {
            { onAction(DecideMVIAction.SubmitJoinCode) }
        } else {
            null
        },
        modifier = Modifier.fillMaxWidth(),
    )
}

@Composable
private fun <T> ChoiceList(
    title: String,
    options: List<Pair<T, String>>,
    selected: T?,
    onSelect: (T) -> Unit,
) {
    TextLabel(
        state = TextLabelState(text = title, color = UiKitTheme.colors.color_2, textStyle = BoldMedium),
        modifier = Modifier.padding(bottom = 16.dp),
    )
    options.forEach { (value, label) ->
        ChoiceChip(
            label = label,
            selected = value == selected,
            onClick = { onSelect(value) },
            modifier = Modifier.fillMaxWidth().padding(bottom = 8.dp),
        )
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun ConstraintsStep(
    state: DecideState,
    onAction: (DecideMVIAction) -> Unit,
) {
    TextLabel(
        state = TextLabelState(
            text = stringResource(Res.string.decide_constraints_title),
            color = UiKitTheme.colors.color_2,
            textStyle = BoldMedium,
        ),
        modifier = Modifier.padding(bottom = 16.dp),
    )
    FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
        listOf(
            TasteTags.HORROR to stringResource(Res.string.decide_tag_horror),
            TasteTags.VIOLENCE to stringResource(Res.string.decide_tag_violence),
            TasteTags.SLOW to stringResource(Res.string.decide_tag_slow),
            TasteTags.ROMANCE to stringResource(Res.string.decide_tag_romance),
            TasteTags.ANIMATION to stringResource(Res.string.decide_tag_animation),
        ).forEach { (tag, label) ->
            ChoiceChip(
                label = label,
                selected = tag in state.excludeTags,
                onClick = { onAction(DecideMVIAction.ToggleTag(tag)) },
            )
        }
        ChoiceChip(
            label = stringResource(Res.string.decide_exclude_watched),
            selected = state.excludeWatched,
            onClick = { onAction(DecideMVIAction.ToggleExcludeWatched) },
        )
    }
    Spacer(Modifier.height(24.dp))
    TextLabel(
        state = TextLabelState(
            text = stringResource(Res.string.decide_preferences_title),
            color = UiKitTheme.colors.color_2,
            textStyle = BoldMedium,
        ),
        modifier = Modifier.padding(bottom = 16.dp),
    )
    FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
        ChoiceChip(
            label = stringResource(Res.string.decide_high_rating),
            selected = state.highRating,
            onClick = { onAction(DecideMVIAction.ToggleHighRating) },
        )
        ChoiceChip(
            label = stringResource(Res.string.decide_with_subtitles),
            selected = !state.noSubtitles,
            onClick = { onAction(DecideMVIAction.ToggleNoSubtitles) },
        )
    }
}

@Composable
private fun PickHeroBackground(imageUrl: String?) {
    Box(modifier = Modifier.fillMaxSize().background(UiKitTheme.colors.color_3)) {
        UiKitImage(
            state = ImageUiKitState(
                url = imageUrl,
                placeholder = painterResource(Res.drawable.movie),
                placeholderColor = UiKitTheme.colors.color_5,
                contentScale = ContentScale.Crop,
            ),
            alignment = Alignment.TopCenter,
            modifier = Modifier.fillMaxSize(),
        )
        Box(
            modifier = Modifier
                .fillMaxSize()
                .background(
                    brush = Brush.verticalGradient(
                        colors = listOf(
                            UiKitTheme.colors.color_3.copy(alpha = 0.45f),
                            UiKitTheme.colors.color_3.copy(alpha = 0.55f),
                            UiKitTheme.colors.color_3.copy(alpha = 0.82f),
                            UiKitTheme.colors.color_3,
                        ),
                    )
                ),
        )
    }
}

@Composable
private fun PickStep(
    padding: PaddingValues,
    state: DecideState,
    onAction: (DecideMVIAction) -> Unit,
) {
    val pick = state.pick
    Box(modifier = Modifier.fillMaxSize()) {
        when {
            state.isLoading -> Box(
                modifier = Modifier.fillMaxSize().padding(padding),
                contentAlignment = Alignment.Center,
            ) {
                CircularProgressIndicator(color = UiKitTheme.colors.color_1, strokeWidth = 2.dp)
            }
            pick == null -> Column(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(padding)
                    .padding(24.dp),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Center,
            ) {
                TextLabel(
                    state = TextLabelState(
                        text = stringResource(Res.string.decide_pick_empty),
                        color = UiKitTheme.colors.color_2,
                        textStyle = Medium,
                        textAlign = TextAlign.Center,
                    ),
                )
                if (state.pickLoadFailed) {
                    Spacer(Modifier.height(20.dp))
                    UiKitButton(
                        state = UiKitButtonState(
                            title = stringResource(Res.string.repeat),
                            titleColor = UiKitTheme.colors.color_7,
                            backgroundColor = UiKitTheme.colors.color_1,
                            contentState = ButtonContentState.ENABLED,
                        ),
                        onClick = { onAction(DecideMVIAction.Reload) },
                        modifier = Modifier.fillMaxWidth(),
                    )
                }
            }
            else -> PickStepContent(padding = padding, pick = pick, state = state, onAction = onAction)
        }
    }
}

@Composable
private fun PickStepContent(
    padding: PaddingValues,
    pick: com.kinoshazam.taste.TastePickDto,
    state: DecideState,
    onAction: (DecideMVIAction) -> Unit,
) {
    Box(modifier = Modifier.fillMaxSize()) {
        Column(
            modifier = Modifier
                .align(Alignment.BottomCenter)
                .fillMaxWidth()
                .padding(padding)
                .navigationBarsPadding()
                .verticalScroll(rememberScrollState())
                .padding(horizontal = 16.dp, vertical = 8.dp),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            TextLabel(
                state = TextLabelState(
                    text = listOfNotNull(pick.title, pick.year?.toString()).joinToString(" · "),
                    color = UiKitTheme.colors.color_2,
                    textStyle = BoldLarge,
                ),
            )
            Spacer(Modifier.height(8.dp))
            TextLabel(
                state = TextLabelState(
                    text = pickReasonText(pick),
                    color = UiKitTheme.colors.color_1,
                    textStyle = Medium,
                ),
            )
            pick.overview?.takeIf { it.isNotBlank() }?.let { overview ->
                Spacer(Modifier.height(12.dp))
                TextLabel(
                    state = TextLabelState(
                        text = overview,
                        color = UiKitTheme.colors.color_2,
                        textStyle = Medium,
                        maxLines = 4,
                    ),
                )
            }
            Spacer(Modifier.height(24.dp))
            val party = state.party
            val locked = party?.isLocked() == true
            val busy = state.isSaving
            val yourVote = party?.yourVote
            if (party != null) {
                TextLabel(
                    state = TextLabelState(
                        text = if (locked) {
                            stringResource(Res.string.decide_party_locked)
                        } else {
                            stringResource(
                                Res.string.decide_party_votes,
                                party.acceptedCount,
                                party.skippedCount,
                            )
                        },
                        color = UiKitTheme.colors.color_1,
                        textStyle = Medium,
                    ),
                )
                Spacer(Modifier.height(12.dp))
                party.members.filter { it.vote != null }.forEach { member ->
                    val name = if (member.isYou) {
                        stringResource(Res.string.decide_party_you)
                    } else {
                        member.displayName
                    }
                    val voteLabel = member.vote?.let { voteKindLabel(it) }
                    ChoiceChip(
                        label = if (voteLabel != null) "$name · $voteLabel" else name,
                        selected = member.vote == TasteVoteKind.ACCEPTED || member.isYou,
                        onClick = {},
                        modifier = Modifier.fillMaxWidth().padding(bottom = 8.dp),
                    )
                }
                Spacer(Modifier.height(8.dp))
            }
            UiKitButton(
                state = UiKitButtonState(
                    title = stringResource(
                        if (party != null && !locked) Res.string.decide_watch_in else Res.string.decide_watch
                    ),
                    titleColor = if (yourVote == TasteVoteKind.ACCEPTED && !locked) {
                        UiKitTheme.colors.color_7
                    } else {
                        UiKitTheme.colors.color_7
                    },
                    backgroundColor = if (yourVote == TasteVoteKind.ACCEPTED && !locked) {
                        UiKitTheme.colors.color_1
                    } else {
                        UiKitTheme.colors.color_1
                    },
                    contentState = when {
                        busy -> ButtonContentState.LOADING
                        else -> ButtonContentState.ENABLED
                    },
                ),
                onClick = if (!busy) {
                    { onAction(DecideMVIAction.WatchPick) }
                } else {
                    null
                },
                modifier = Modifier.fillMaxWidth(),
            )
            if (party?.canLock == true) {
                Spacer(Modifier.height(8.dp))
                UiKitButton(
                    state = UiKitButtonState(
                        title = stringResource(Res.string.decide_party_lock),
                        titleColor = UiKitTheme.colors.color_2,
                        backgroundColor = UiKitTheme.colors.color_4,
                        contentState = if (busy) ButtonContentState.LOADING else ButtonContentState.ENABLED,
                    ),
                    onClick = if (!busy) {
                        { onAction(DecideMVIAction.LockPick) }
                    } else {
                        null
                    },
                    modifier = Modifier.fillMaxWidth(),
                )
            }
            val showReject = party == null || !locked || party.canForceNext
            if (showReject) {
                Spacer(Modifier.height(8.dp))
                UiKitButton(
                    state = UiKitButtonState(
                        title = stringResource(Res.string.decide_another),
                        titleColor = UiKitTheme.colors.color_2,
                        backgroundColor = if (yourVote == TasteVoteKind.SKIPPED) {
                            UiKitTheme.colors.color_1.copy(alpha = 0.35f)
                        } else {
                            UiKitTheme.colors.color_4
                        },
                        contentState = if (busy) ButtonContentState.LOADING else ButtonContentState.ENABLED,
                    ),
                    onClick = if (!busy) {
                        { onAction(DecideMVIAction.AnotherPick) }
                    } else {
                        null
                    },
                    modifier = Modifier.fillMaxWidth(),
                )
            }
            if (party == null || !locked) {
                Spacer(Modifier.height(8.dp))
                UiKitButton(
                    state = UiKitButtonState(
                        title = stringResource(Res.string.decide_not_for_me),
                        titleColor = UiKitTheme.colors.color_2,
                        backgroundColor = if (yourVote == TasteVoteKind.NOT_INTERESTED) {
                            UiKitTheme.colors.color_1.copy(alpha = 0.35f)
                        } else {
                            UiKitTheme.colors.color_4
                        },
                        contentState = if (busy) ButtonContentState.LOADING else ButtonContentState.ENABLED,
                    ),
                    onClick = if (!busy) {
                        { onAction(DecideMVIAction.NotForMe) }
                    } else {
                        null
                    },
                    modifier = Modifier.fillMaxWidth(),
                )
                Spacer(Modifier.height(8.dp))
                UiKitButton(
                    state = UiKitButtonState(
                        title = stringResource(Res.string.decide_already_watched),
                        titleColor = UiKitTheme.colors.color_2,
                        backgroundColor = UiKitTheme.colors.color_4,
                        contentState = if (busy) ButtonContentState.LOADING else ButtonContentState.ENABLED,
                    ),
                    onClick = if (!busy) {
                        { onAction(DecideMVIAction.AlreadyWatched) }
                    } else {
                        null
                    },
                    modifier = Modifier.fillMaxWidth(),
                )
            }
            if (!locked) {
                Spacer(Modifier.height(8.dp))
                UiKitButton(
                    state = UiKitButtonState(
                        title = stringResource(Res.string.decide_edit_seeds),
                        titleColor = UiKitTheme.colors.color_2,
                        backgroundColor = UiKitTheme.colors.color_4,
                    ),
                    onClick = { onAction(DecideMVIAction.EditSeeds) },
                    modifier = Modifier.fillMaxWidth(),
                )
            }
            Spacer(Modifier.height(16.dp))
        }
    }
}

@Composable
private fun voteKindLabel(kind: TasteVoteKind): String {
    return when (kind) {
        TasteVoteKind.ACCEPTED -> stringResource(Res.string.decide_vote_watch)
        TasteVoteKind.SKIPPED -> stringResource(Res.string.decide_vote_skip)
        TasteVoteKind.NOT_INTERESTED -> stringResource(Res.string.decide_vote_pass)
        TasteVoteKind.ALREADY_WATCHED -> stringResource(Res.string.decide_vote_seen)
    }
}

@Composable
private fun pickReasonText(pick: com.kinoshazam.taste.TastePickDto): String {
    return when (pick.reasonKey) {
        TasteReasonKeys.SIMILAR_TO_FAVORITE ->
            stringResource(Res.string.decide_reason_similar, pick.reasonTitle.orEmpty())
        TasteReasonKeys.FAMILY_NIGHT -> stringResource(Res.string.decide_reason_family)
        TasteReasonKeys.MATCHES_MOOD -> stringResource(Res.string.decide_reason_mood)
        TasteReasonKeys.FITS_TIME -> stringResource(Res.string.decide_reason_time)
        TasteReasonKeys.SURPRISE -> stringResource(Res.string.decide_reason_surprise)
        TasteReasonKeys.FROM_YOUR_TASTE -> stringResource(Res.string.decide_reason_from_taste)
        TasteReasonKeys.HIGH_RATING -> stringResource(Res.string.decide_reason_high_rating)
        TasteReasonKeys.TOGETHER ->
            stringResource(Res.string.decide_reason_together, pick.reasonTitle.orEmpty())
        else -> stringResource(Res.string.decide_reason_popular)
    }
}

@Composable
private fun ExitConfirmOverlay(
    onAction: (DecideMVIAction) -> Unit,
) {
    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(UiKitTheme.colors.color_3.copy(alpha = 0.72f))
            .clickable(
                indication = null,
                interactionSource = remember { MutableInteractionSource() },
                onClick = { onAction(DecideMVIAction.DismissExit) },
            ),
        contentAlignment = Alignment.Center,
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .clip(RoundedCornerShape(16.dp))
                .background(UiKitTheme.colors.color_4)
                .clickable(
                    indication = null,
                    interactionSource = remember { MutableInteractionSource() },
                    onClick = {},
                )
                .padding(20.dp),
        ) {
            TextLabel(
                state = TextLabelState(
                    text = stringResource(Res.string.decide_exit_title),
                    color = UiKitTheme.colors.color_2,
                    textStyle = BoldLarge,
                ),
            )
            Spacer(Modifier.height(8.dp))
            TextLabel(
                state = TextLabelState(
                    text = stringResource(Res.string.decide_exit_body),
                    color = UiKitTheme.colors.color_2,
                    textStyle = Medium,
                ),
            )
            Spacer(Modifier.height(20.dp))
            UiKitButton(
                state = UiKitButtonState(
                    title = stringResource(Res.string.decide_exit_stay),
                    titleColor = UiKitTheme.colors.color_7,
                    backgroundColor = UiKitTheme.colors.color_1,
                ),
                onClick = { onAction(DecideMVIAction.DismissExit) },
                modifier = Modifier.fillMaxWidth(),
            )
            Spacer(Modifier.height(8.dp))
            UiKitButton(
                state = UiKitButtonState(
                    title = stringResource(Res.string.decide_exit_leave),
                    titleColor = UiKitTheme.colors.color_2,
                    backgroundColor = UiKitTheme.colors.color_3,
                ),
                onClick = { onAction(DecideMVIAction.ConfirmExit) },
                modifier = Modifier.fillMaxWidth(),
            )
        }
    }
}

@Composable
private fun ChoiceChip(
    label: String,
    selected: Boolean,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    val shape = RoundedCornerShape(12.dp)
    Box(
        modifier = modifier
            .clip(shape)
            .background(if (selected) UiKitTheme.colors.color_1.copy(alpha = 0.2f) else UiKitTheme.colors.color_4)
            .border(
                width = 1.dp,
                color = if (selected) UiKitTheme.colors.color_1 else UiKitTheme.colors.color_4,
                shape = shape,
            )
            .clickable(onClick = onClick)
            .padding(horizontal = 16.dp, vertical = 14.dp)
    ) {
        TextLabel(
            state = TextLabelState(
                text = label,
                color = UiKitTheme.colors.color_2,
                textStyle = if (selected) BoldMedium else Medium,
            )
        )
    }
}

@Composable
private fun SeedCard(
    item: TasteCatalogItem,
    selected: Boolean,
    onAction: (DecideMVIAction) -> Unit,
) {
    val posterShape = RoundedCornerShape(8.dp)
    Column(modifier = Modifier.fillMaxWidth()) {
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .aspectRatio(2f / 3f)
                .clip(posterShape)
                .clickable { onAction(DecideMVIAction.ToggleSeed(item)) }
        ) {
            UiKitImage(
                state = ImageUiKitState(
                    url = item.imageUrl,
                    placeholder = painterResource(Res.drawable.movie),
                    placeholderColor = UiKitTheme.colors.color_5,
                    contentScale = ContentScale.Crop,
                ),
                modifier = Modifier.fillMaxSize(),
            )
            if (selected) {
                Box(
                    modifier = Modifier
                        .matchParentSize()
                        .border(2.dp, UiKitTheme.colors.color_1, posterShape)
                        .background(UiKitTheme.colors.color_3.copy(alpha = 0.28f))
                )
                SelectedCheckBadge(
                    modifier = Modifier
                        .align(Alignment.TopEnd)
                        .padding(8.dp),
                )
            }
        }
        TextLabel(
            state = TextLabelState(
                text = item.title,
                color = if (selected) UiKitTheme.colors.color_1 else UiKitTheme.colors.color_2,
                textStyle = MediumSmall,
                maxLines = 2,
            ),
            modifier = Modifier.padding(top = 6.dp, start = 2.dp, end = 2.dp),
        )
    }
}

@Composable
private fun SelectedCheckBadge(modifier: Modifier = Modifier) {
    val checkColor = UiKitTheme.colors.color_7
    Box(
        modifier = modifier
            .size(22.dp)
            .clip(CircleShape)
            .background(UiKitTheme.colors.color_1),
        contentAlignment = Alignment.Center,
    ) {
        Canvas(modifier = Modifier.size(11.dp)) {
            val stroke = size.minDimension * 0.18f
            drawLine(
                color = checkColor,
                start = Offset(size.width * 0.12f, size.height * 0.52f),
                end = Offset(size.width * 0.38f, size.height * 0.78f),
                strokeWidth = stroke,
                cap = StrokeCap.Round,
            )
            drawLine(
                color = checkColor,
                start = Offset(size.width * 0.38f, size.height * 0.78f),
                end = Offset(size.width * 0.88f, size.height * 0.22f),
                strokeWidth = stroke,
                cap = StrokeCap.Round,
            )
        }
    }
}
